var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { MenuItem as BaseMenuItem, Checkbox, Stack } from "../components";
export const CheckboxMenuItem = (_a) => {
    var { selected, startNode, disabled } = _a, props = __rest(_a, ["selected", "startNode", "disabled"]);
    return (React.createElement(BaseMenuItem, Object.assign({ startNode: React.createElement(Stack, { flexDirection: "row", gap: 2, alignItems: "center" },
            React.createElement(Checkbox, { as: "div", checked: selected, disabled: disabled }),
            startNode), disabled: disabled }, props)));
};
//# sourceMappingURL=CheckboxMenuItem.js.map